import React from 'react';
import PropTypes from 'prop-types';
import { SuccessScreen } from 'shared/components';
import './TCRenewalSubmitted.scss';

const TCRenewalSubmitted = props =>
  (
    <div className="successfully-submitted">
      <SuccessScreen data={{
        copy: props.TCUrlAction === 'renewal' ? 'testCenter.successfullySubmitted.renewalMessage' : 'testCenter.successfullySubmitted.establishmentMessage',
        buttonLabel: 'testCenter.successfullySubmitted.buttonLabel',
        buttonClass: 'btn-primary',
        callback: () => {
          props.history.go(-props.stepsBack);
        },
      }}
      />
    </div>
  );

export default TCRenewalSubmitted;
